import {
  ElementType,
  ReactNode,
  forwardRef,
  ComponentPropsWithRef,
  PropsWithRef,
} from 'react';
import classNames from 'classnames';
import { TypographyTypes, TypographyWeights, Colors } from '../../styles';
import styles from './Typography.module.scss';

interface _TypographyProps<T extends ElementType> {
  textWeight?: TypographyWeights;
  textType: TypographyTypes;
  children: ReactNode;
  className?: string;
  textColor?: Colors;
  as?: T;
}

export type TypographyProps<T extends ElementType> = ComponentPropsWithRef<T> &
  PropsWithRef<_TypographyProps<T>>;

function Typography<T extends ElementType = 'span'>(
  {
    textColor = 'text-1',
    textWeight,
    textStyle,
    className,
    textType,
    as,
    ...props
  }: TypographyProps<T>,
  ref: any,
) {
  const Component = as ?? 'span';
  return (
    <Component
      {...props}
      className={classNames(
        textWeight && styles[`text--w-${textWeight}`],
        textColor && styles[`text--c-${textColor}`],
        textType && styles[`text--t-${textType}`],
        styles.text,
        className,
      )}
      ref={ref}
    />
  );
}

export default forwardRef(Typography);
